import React from 'react';
import {Link} from 'react-router-dom';
import styles from './Header.module.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faUser,
    faHouse,
    faPersonRunning,
    faCalendarAlt,
    faChartBar,
    faChartColumn, faBuildingShield, faUnlockKeyhole, faShieldHalved, faShieldVirus, faUserShield, faShieldAlt
} from '@fortawesome/free-solid-svg-icons';
import logoEntreprise from '../../assets/images/elanciaatwork.png';
import {useUser} from "../../contexts/UserContext";
import {faKeybase, faKeycdn} from "@fortawesome/free-brands-svg-icons";
import Routing from "../../services/routing";

function Header() {
    const {user, setUser, loading} = useUser();

    let headerClass = `${styles.header}`;
    // if (user && user.roles.includes("ROLE_ADMIN")) {
    //     headerClass = `${styles.header} ${styles.headerAdmin}`;
    // }

    return <>
        <header className={`${headerClass}`}>
            <Link to={Routing.routes.home} className={styles.homeLink}>
                <FontAwesomeIcon icon={faHouse} className={styles.svg}/>
            </Link>
            <div className={styles.logo}>
                <Link to={Routing.routes.home} className={styles.homeLink}>
                    <img src={user && user.entreprise ? user.entreprise.logo : logoEntreprise} alt="logo entreprise"
                         className={styles.logoEntreprise}/>
                </Link>
            </div>
            <Link to={Routing.routes.profil} className={styles.profileButton}>
                <FontAwesomeIcon icon={faUser} className={styles.svg}/>
            </Link>
        </header>

        <header className={styles.desktopHeader}>
            <div className={styles.logo}>
                <Link to={Routing.routes.home} className={styles.homeLink}>
                    <img
                        src={user && user.entreprise ? user.entreprise.logo : logoEntreprise}
                        alt="logo entreprise" className={styles.logoEntreprise}/>
                </Link>
            </div>
            <Link to={Routing.routes.home} className={styles.homeLink} title={"Accueil"}>
                <FontAwesomeIcon icon={faHouse} className={styles.svg}/>
            </Link>
            {user && (user.roles.includes("ROLE_ADMIN") || user.roles.includes("ROLE_SUPER_ADMIN")) &&
                <Link to={Routing.routes.admin} className={styles.homeLink} title={"Tableau de bord admin"}>
                    <FontAwesomeIcon icon={faShieldAlt} className={styles.svg}/>
                </Link>
            }

            {user && (user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_REFERENT")) &&
                <Link to={Routing.routes.seancesEnregistrees} className={styles.homeLink}
                      title={"Séances enregistrées"}>
                    <FontAwesomeIcon icon={faPersonRunning} className={styles.svg}/>
                </Link>
            }
            <Link to={Routing.routes.planning} className={styles.homeLink} title={"Planning"}>
                <FontAwesomeIcon icon={faCalendarAlt} className={styles.svg}/>
            </Link>

            {user && (user.roles.includes("ROLE_ADMIN") || user.roles.includes("ROLE_SUPER_ADMIN") || user.roles.includes("ROLE_REFERENT")) &&
                <Link to={Routing.routes.statsMain} className={styles.homeLink} title={"Statistiques"}>
                    <FontAwesomeIcon icon={faChartColumn} className={styles.svg}/>
                </Link>
            }

            <Link to={Routing.routes.profil} className={styles.profileButton} title={"Mon profil"}>
                <FontAwesomeIcon icon={faUser} className={styles.svg}/>
            </Link>
        </header>
    </>
}

export default Header;
